import React, { useEffect, useState } from "react";
import T from "i18n-react";
import TipCards from "../../Widgets/TipCards/TipCards";
import Styles from "../styles.module.scss";
import TipInput from "./TipInput";
import { setTipPrice } from "../reducer/PaymentActions";
import { priceToPounds } from "../../../utils/pricingCalculator";
import { addTaxes } from "../../../yoello-lib/modules/utils/TaxController";

interface ITipComponentProps {
  dispatch: React.Dispatch<any>;
  itemCost: number;
  transactionFee: number;
  deliveryCharge: number;
  totalCost: number;
  cartItemTaxAmount: number;
  serviceTaxAmount: number;
  tipTotal: number;
  deliveryTaxAmount: number;
}

enum TipType {
  ROUNDUP,
  TENPERCENT,
  CUSTOM,
  ZERO,
}
function TipComponent({
  dispatch,
  itemCost,
  deliveryCharge,
  transactionFee,
  totalCost,
  cartItemTaxAmount,
  serviceTaxAmount,
  tipTotal,
  deliveryTaxAmount,
}: ITipComponentProps) {
  const [tipType, setTipType] = useState<TipType>(TipType.ZERO);
  const [customValue, setCustomValue] = useState<number>();
  useEffect(() => {
    dispatch(setTipPrice(getTips()));
    // eslint-disable-next-line
  }, [tipType, customValue]);
  function getTips() {
    const totalTax = addTaxes(
      cartItemTaxAmount,
      serviceTaxAmount,
      deliveryTaxAmount
    );
    let price;
    switch (tipType) {
      case TipType.ZERO:
        return 0;
      case TipType.ROUNDUP:
        const roundUpPrice = totalCost + totalTax - tipTotal;
        price = priceToPounds(roundUpPrice);
        //@ts-ignore
        return (Math.ceil(price) - price) * 100;
      case TipType.TENPERCENT:
        // price = itemCost;
        price = totalCost + totalTax - tipTotal;
        price = (price * 10) / 100;
        return price;
      case TipType.CUSTOM:
        if (customValue) {
          return customValue * 100;
        } else {
          return 0;
        }
      default:
        return 0;
    }
  }
  return (
    <div className={Styles.TipsSectionDiv}>
      <T.p
        className={Styles.TipStaffText}
        text={{ key: `ShopCart.TipStaffText` }}
      />
      <div
        className="Flex AlignCenter"
        style={{
          justifyContent: "space-between",
        }}
      >
        <TipCards
          selected={tipType === TipType.ZERO}
          title="Zero"
          onClick={() => setTipType(TipType.ZERO)}
        />
        <TipCards
          selected={tipType === TipType.ROUNDUP}
          title="Roundup"
          onClick={() => {
            setTipType(TipType.ROUNDUP);
          }}
        />
        <TipCards
          selected={tipType === TipType.TENPERCENT}
          title="10%"
          onClick={() => setTipType(TipType.TENPERCENT)}
        />
        {tipType === TipType.CUSTOM ? (
          <div
            className={Styles.TipCardInputDiv}
            style={{
              position: "relative",
            }}
          >
            <TipInput
              customTipValue={customValue}
              onChangeCustomTip={setCustomValue}
            />
          </div>
        ) : (
          <TipCards
            title="Custom"
            onClick={() => {
              setTipType(TipType.CUSTOM);
            }}
          />
        )}
      </div>
    </div>
  );
}
export default React.memo(TipComponent);
